import { render, staticRenderFns } from "./FileSignatureStructure.vue?vue&type=template&id=57ba42ef"
import script from "./FileSignatureStructure.vue?vue&type=script&lang=ts"
export * from "./FileSignatureStructure.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports